import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Spacing from "../../../layout/spacing";
import HalfWayImage from "../../../assets/images/half-way.png";
import HalfWayImageWebp from "../../../assets/images/half-way.webp";
import TrainImage from "../../../assets/images/statement-located.png";
import TrainImageWebp from "../../../assets/images/statement-located.webp";
import VectorWrapper from "../../../components/vector-wrapper";
import useImageLoader from "../../../utils/useLoadImage";
import LoadingScreen from "../../general/loading-screen";
import { TRANSFER_FLOW_OUT } from "../../../typings";
import HeadingContainer from "../../../layout/heading-container";
import { HeadlineMedium } from "../../../components/font";
import { Button } from "@manifesthhqinc/ui-library";

const OldAccountFinishScreen: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, userDetails, onClickContinue, partnerConfig, transferFlow } = props;
  const { imageSrc, webpSrc } = useImageLoader({
    imgSrc: transferFlow === TRANSFER_FLOW_OUT ? TrainImage : HalfWayImage,
    webp: transferFlow === TRANSFER_FLOW_OUT ? TrainImageWebp : HalfWayImageWebp,
  });

  if (process.env.NODE_ENV !== "test" && !imageSrc && !webpSrc) {
    return <LoadingScreen loadingScreenMessage="" />;
  }

  if (transferFlow === TRANSFER_FLOW_OUT) {
    return (
      <TransitionWrapper>
        <ScrollableContainer name={currentSourceAccountStep}>
          <Container>
            <HeadingContainer paneVariant="vector" withProgressBar>
              <HeadlineMedium $textAlign="center">Let’s find the best place for your old account</HeadlineMedium>
            </HeadingContainer>
            <VectorWrapper
              imgSrc={imageSrc}
              webpSrc={webpSrc}
              imgAlt="celebration-half-way-through"
              name="celebration-half-way-through"
            />
            <Spacing vertical="50" />
            <p className="text-center form-description-with-vector">
              Since we’ve partnered with {partnerConfig}, you can transfer directly into an {partnerConfig} account, or
              let Manifest help you choose the best option.
            </p>
          </Container>
        </ScrollableContainer>

        <Footer>
          <Button onClick={onClickContinue} name="continue" size="large">
            Continue
          </Button>
        </Footer>
      </TransitionWrapper>
    );
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar>
            <HeadlineMedium $textAlign="center">
              Fantastic work, {userDetails?.firstName || ""}! You're well over halfway through.
            </HeadlineMedium>
          </HeadingContainer>
          <VectorWrapper
            imgSrc={imageSrc}
            webpSrc={webpSrc}
            imgAlt="celebration-half-way-through"
            name="celebration-half-way-through"
          />
        </Container>
      </ScrollableContainer>

      <Footer>
        <p className="text-center disclaimer-text no-max-width">
          {partnerConfig} has partnered up with Manifest to make your transfer as seamless as possible.
          <br />
          Next, we’ll connect your {partnerConfig} account details for a smooth and accurate transfer.
        </p>
        <Button onClick={onClickContinue} name="continue" size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default OldAccountFinishScreen;
